/* Ghost Hunt cart drawer: one-tap add-ons and reward claims.
   Adds go through the same path as the theme's product form (cart/add.js with
   bundled sections → cartUpdate pubsub), so the drawer, cart count and every
   section inside the drawer re-render from the server. */
(() => {
  if (window.__ghCart) return;
  window.__ghCart = true;

  const scroller = () => document.querySelector('#CartDrawer .gh-cart__scroll');
  let savedScroll = null;

  // Keep the reader's place: the theme replaces the whole panel after each change.
  const rememberScroll = (event) => {
    if (!event.target.closest || !event.target.closest('#CartDrawer .gh-cart__scroll')) return;
    const el = scroller();
    if (el) savedScroll = el.scrollTop;
  };
  document.addEventListener('click', rememberScroll, true);
  document.addEventListener('change', rememberScroll, true);
  document.addEventListener('cart:updated', () => {
    if (savedScroll === null) return;
    const el = scroller();
    if (el) el.scrollTop = savedScroll;
    savedScroll = null;
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-gh-add]');
    if (!button || !window.theme || !theme.routes) return;
    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;

    button.setAttribute('aria-busy', 'true');
    button.classList.add('is-loading');

    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));

    const item = { id: Number(button.getAttribute('data-gh-add')), quantity: 1 };
    if (button.hasAttribute('data-gh-reward')) item.properties = { _gh_reward: 'Free reward' };

    try {
      const response = await fetch(theme.routes.cart_add_url, {
        ...theme.utils.fetchConfig('javascript'),
        body: JSON.stringify({ items: [item], sections, sections_url: window.location.pathname })
      });
      const added = await response.json();
      if (added.status) throw new Error(added.description || added.message || 'Could not add item');

      const cart = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })).json();
      cart.sections = added.sections;
      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'gh-cart', cart });
    }
    catch (error) {
      console.error(error);
      button.removeAttribute('aria-busy');
      button.classList.remove('is-loading');
      button.classList.add('is-error');
      const label = button.querySelector('span');
      if (label) label.textContent = 'Unavailable';
    }
  });
})();
